<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="layout--main"
    :class="[
      layoutTypeClass,
      navbarClasses,
      footerClasses,
      { 'no-scroll': isAppPage },
    ]"
  >
    <v-nav-menu :navMenuItems="navMenuItems" title="Vuexy" parent=".layout--main" />

    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1024">
        <!-- di edit dulu sama Yusuf Eka Wicaksana  -->
        <the-navbar-horizontal
          :navbarType="navbarType"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />

        <div style="height: 62px;" v-if="navbarType === 'static'"></div>

        <!-- <h-nav-menu
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
          :navMenuItems="navMenuItems"
        />-->
      </template>

      <template v-else>
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper" id="block-margin-content">
        <div class="router-view">
          <div class="router-content">
            <transition :name="routerTransition">
              <div
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6"
              >
                <div
                  class="content-area__heading"
                  :class="{
                    'pr-4 border-0 md:border-r border-solid border-grey-light':
                      $route.meta.breadcrumb,
                  }"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb
                  class="ml-4 md:block hidden"
                  v-if="$route.meta.breadcrumb"
                  :route="$route"
                  :isRTL="$vs.rtl"
                />
              </div>
            </transition>

            <div class="content-area__content">
              <div
                v-if="showGlobalSubmenuShortcuts"
                class="module-shortcuts"
                :class="{ 'is-compact': isShortcutCompact || isShortcutCollapsed }"
              >
                <div class="module-shortcuts__top">
                  <div class="module-shortcuts__search" :class="{ 'search-hidden': isMobileSearchHidden }">
                    <feather-icon icon="SearchIcon" size="14" class="mr-2" />
                    <input
                      v-model.trim="submenuSearch"
                      type="text"
                      placeholder="Cari submenu..."
                    />
                  </div>

                  <div class="module-shortcuts__actions">
                    <button
                      type="button"
                      class="module-shortcuts__icon-btn"
                      @click="toggleMobileSearch"
                      title="Cari submenu"
                    >
                      <feather-icon :icon="isMobileSearchHidden ? 'SearchIcon' : 'XIcon'" size="14" />
                    </button>
                    <button
                      type="button"
                      class="module-shortcuts__collapse-btn"
                      @click="toggleShortcutCollapsed"
                    >
                      <feather-icon
                        :icon="isShortcutCollapsed ? 'ChevronDownIcon' : 'ChevronUpIcon'"
                        size="14"
                      />
                    </button>
                  </div>
                </div>

                <div v-show="!isShortcutCollapsed" class="module-shortcuts__body">
                  <div class="module-shortcuts__scroll">
                    <router-link
                      v-for="(item, idx) in mobileAllChips"
                      :key="item.url + idx"
                      :to="{ name: item.url, params: {} }"
                      class="module-shortcut-chip"
                      :class="{ active: isModuleShortcutActive(item) }"
                      :title="item.menu"
                      @click.native="onShortcutSelected"
                    >
                      <feather-icon :icon="item.icon" size="13" class="chip-icon" />
                      <span class="chip-label">{{ item.menu }}</span>
                    </router-link>
                  </div>

                  <div class="module-shortcuts__overflow" v-if="!isMobileView && overflowShortcutChips.length">
                    <button
                      type="button"
                      class="module-shortcuts__more-btn"
                      @click="toggleMoreShortcuts"
                    >
                      Lainnya ({{ overflowShortcutChips.length }})
                    </button>

                    <div
                      v-if="showMoreShortcuts"
                      class="module-shortcuts__more-panel"
                    >
                      <router-link
                        v-for="(item, idx) in overflowShortcutChips"
                        :key="item.url + '_more_' + idx"
                        :to="{ name: item.url, params: {} }"
                        class="module-shortcuts__more-item"
                        @click.native="onShortcutSelected"
                      >
                        <feather-icon :icon="item.icon" size="13" class="mr-2" />
                        {{ item.menu }}
                      </router-link>
                    </div>
                  </div>

                  <div
                    v-if="!filteredModuleSubmenus.length"
                    class="module-shortcuts__empty"
                  >
                    Submenu tidak ditemukan.
                  </div>
                </div>
              </div>

              <back-to-top
                bottom="5%"
                :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'"
                visibleoffset="500"
                v-if="!hideScrollToTop"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg btn-back-to-top"
                />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view
                  @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="
                    (classesStr) => $emit('setAppClasses', classesStr)
                  "
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <!-- <the-footer /> -->
    </div>
  </div>
</template>

<script>
import BackToTop from "vue-backtotop";
// import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue";
import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js";
import TheNavbarHorizontal from "@/layouts/components/navbar/TheNavbarHorizontal.vue";
import TheNavbarVertical from "@/layouts/components/navbar/TheNavbarVertical.vue";
// import TheFooter from "@/layouts/components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import VNavMenu from "@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue";
import AkademikSubmenus from "@/components/sipt-components/menus/submenu-items/akademikSubMenuItems.js";
import DekanSubmenus from "@/components/sipt-components/menus/submenu-items/dekanSubMenuItems.js";
import DosenSubmenus from "@/components/sipt-components/menus/submenu-items/dosenSubMenuItems.js";
import FeederSubmenus from "@/components/sipt-components/menus/submenu-items/feederSubMenuItems.js";
import SisterSubmenus from "@/components/sipt-components/menus/submenu-items/sisterSubMenuItems.js";
import KepegawaianSubmenus from "@/components/sipt-components/menus/submenu-items/kepegawaianSubMenuItems.js";
import KorprodiSubmenus from "@/components/sipt-components/menus/submenu-items/korprodiSubMenuItems.js";
import LppmSubmenus from "@/components/sipt-components/menus/submenu-items/lppmSubMenuItems.js";
import PerpustakaanSubmenus from "@/components/sipt-components/menus/submenu-items/perpustakaanSubMenuItems.js";
import TendikSubmenus from "@/components/sipt-components/menus/submenu-items/tendikSubMenuItems.js";
import TataUsahaSubmenus from "@/components/sipt-components/menus/submenu-items/tataUsahaSubMenuItems.js";
import KoorTaSubmenus from "@/components/sipt-components/menus/submenu-items/koorTaSubMenuItems.js";
import PusdatinSubmenus from "@/components/sipt-components/menus/submenu-items/pusdatinSubMenuItems.js";
import Lp3mSubmenus from "@/components/sipt-components/menus/submenu-items/lp3mSubMenuItems.js";
import KerjasamaSubmenus from "@/components/sipt-components/menus/submenu-items/kerjasamaSubMenuItems.js";
import KemahasiswaanSubmenus from "@/components/sipt-components/menus/submenu-items/kemahasiswaanSubMenuItems.js";
import SpiSubmenus from "@/components/sipt-components/menus/submenu-items/spiSubMenuItems.js";

export default {
  components: {
    BackToTop,
    // HNavMenu,
    // TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
  },
  data() {
    return {
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: themeConfig.navbarType || "floating", //ini yang diubah yusuf eka wicaksana
      navMenuItems: navMenuItems,
      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
      submenuSearch: "",
      shortcutVisibleLimit: 8,
      showMoreShortcuts: false,
      isShortcutCollapsed: false,
      isShortcutCompact: false,
      isMobileSearchHidden: true,
    };
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.replace({ name: "page-login" });
    }

    this.handleShortcutScroll();
    window.addEventListener("scroll", this.handleShortcutScroll, {
      passive: true,
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleShortcutScroll);
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
      this.showMoreShortcuts = false;
      this.submenuSearch = "";
      this.isShortcutCollapsed = false;
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
    },
  },
  computed: {
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default")
          return "content-area-reduced";
        else if (this.verticalNavMenuWidth == "reduced")
          return "content-area-lg";
        else return "content-area-full";
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static",
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating",
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    routeFirstSegment() {
      const path = this.$route.path || "";
      const segment = path.split("/").filter(Boolean)[0] || "";
      return segment;
    },
    moduleKeyFromBreadcrumb() {
      const breadcrumb = (this.$route.meta && this.$route.meta.breadcrumb) || [];
      const submenuCrumb = breadcrumb.find(
        (item) => item && item.url && String(item.url).startsWith("/submenu/")
      );

      if (!submenuCrumb || !submenuCrumb.url) {
        return "";
      }

      return String(submenuCrumb.url)
        .replace("/submenu/", "")
        .split("/")[0]
        .trim();
    },
    activeModuleKey() {
      return this.moduleKeyFromBreadcrumb || this.routeFirstSegment;
    },
    submenuMap() {
      return {
        akademik: AkademikSubmenus,
        dekan: DekanSubmenus,
        dosen: DosenSubmenus,
        feeder: FeederSubmenus,
        sister: SisterSubmenus,
        kepegawaian: KepegawaianSubmenus,
        korprodi: KorprodiSubmenus,
        lppm: LppmSubmenus,
        perpustakaan: PerpustakaanSubmenus,
        tendik: TendikSubmenus,
        "tata-usaha": TataUsahaSubmenus,
        tatausaha: TataUsahaSubmenus,
        tu: TataUsahaSubmenus,
        koorta: KoorTaSubmenus,
        pusdatin: PusdatinSubmenus,
        lp3m: Lp3mSubmenus,
        kerjasama: KerjasamaSubmenus,
        kemahasiswaan: KemahasiswaanSubmenus,
        spi: SpiSubmenus,
      };
    },
    activeModuleSubmenus() {
      return this.submenuMap[this.activeModuleKey] || [];
    },
    filteredModuleSubmenus() {
      const q = (this.submenuSearch || "").toLowerCase();
      if (!q) {
        return this.activeModuleSubmenus;
      }

      return this.activeModuleSubmenus.filter((item) =>
        (item.menu || "").toLowerCase().includes(q)
      );
    },
    isMobileView() {
      return this.windowWidth <= 768;
    },
    mobileAllChips() {
      return this.isMobileView
        ? this.filteredModuleSubmenus
        : this.visibleShortcutChips;
    },
    visibleShortcutChips() {
      return this.filteredModuleSubmenus.slice(0, this.shortcutVisibleLimit);
    },
    overflowShortcutChips() {
      return this.filteredModuleSubmenus.slice(this.shortcutVisibleLimit);
    },
    showGlobalSubmenuShortcuts() {
      const path = this.$route.path || "";
      return !path.startsWith("/submenu/") && this.activeModuleSubmenus.length > 0;
    },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      if (val == "static")
        this.updateNavbarColor(this.isThemeDark ? "#10163a" : "#fff");
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === "horizontal" && this.windowWidth >= 1024) ||
        (layoutType === "vertical" && this.windowWidth < 1024)
      ) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    handleShortcutScroll() {
      this.isShortcutCompact = window.scrollY > 120;
    },
    toggleMobileSearch() {
      this.isMobileSearchHidden = !this.isMobileSearchHidden;
      if (!this.isMobileSearchHidden) {
        this.$nextTick(() => {
          const input = this.$el.querySelector(".module-shortcuts__search input");
          if (input) input.focus();
        });
      } else {
        this.submenuSearch = "";
      }
    },
    toggleShortcutCollapsed() {
      this.isShortcutCollapsed = !this.isShortcutCollapsed;
    },
    toggleMoreShortcuts() {
      this.showMoreShortcuts = !this.showMoreShortcuts;
    },
    onShortcutSelected() {
      this.showMoreShortcuts = false;
    },
    isModuleShortcutActive(item) {
      const routeName = this.$route.name || "";
      return routeName === item.url || routeName.startsWith(item.url);
    },
  },
  created() {
    const color =
      this.navbarColor == "#fff" && this.isThemeDark
        ? "#10163a"
        : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);
  },
};
</script>
<style scoped>
#block-margin-content {
  margin-top: -60px;
}

.module-shortcuts {
  margin-bottom: 12px;
  padding: 8px;
  border: 1px solid #dbe5f7;
  border-radius: 10px;
  background: #f9fbff;
  position: sticky;
  top: 66px;
  z-index: 9998;
}

.module-shortcuts__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.module-shortcuts__search {
  flex: 1;
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 0 10px;
  border: 1px solid #d8e1f5;
  border-radius: 999px;
  background: #fff;
  color: #62739a;
}

.module-shortcuts__search input {
  width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 12px;
}

.module-shortcuts__collapse-btn {
  width: 34px;
  height: 34px;
  border: 1px solid #d8e1f5;
  border-radius: 999px;
  background: #fff;
  color: #4a618f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.module-shortcuts__body {
  margin-top: 8px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.module-shortcuts__scroll {
  flex: 1;
  display: flex;
  gap: 8px;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: thin;
  padding-bottom: 2px;
}

.module-shortcut-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  min-height: 34px;
  max-width: 220px;
  flex: 0 0 auto;
  border: 1px solid #d8e1f5;
  border-radius: 999px;
  color: #3f537d;
  background: #fff;
  font-size: 11px;
  font-weight: 600;
  text-decoration: none;
}

.module-shortcut-chip.active {
  border-color: #4b8df8;
  background: #eef5ff;
  color: #1f4e99;
}

.module-shortcut-chip .chip-icon {
  flex: 0 0 auto;
}

.module-shortcut-chip .chip-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.module-shortcuts__overflow {
  position: relative;
  flex: 0 0 auto;
  z-index: 9999;
}

.module-shortcuts__more-btn {
  min-height: 34px;
  border: 1px solid #d8e1f5;
  border-radius: 999px;
  background: #fff;
  color: #3f537d;
  font-size: 11px;
  font-weight: 600;
  padding: 6px 10px;
}

.module-shortcuts__more-panel {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  bottom: auto;
  min-width: 220px;
  max-height: 280px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #d8e1f5;
  border-radius: 10px;
  box-shadow: 0 12px 20px rgba(36, 57, 102, 0.15);
  padding: 6px;
  z-index: 10000;
}

.module-shortcuts__more-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #3f537d;
  padding: 7px 8px;
  border-radius: 8px;
  text-decoration: none;
}

.module-shortcuts__more-item:hover {
  background: #eef5ff;
  color: #1f4e99;
}

.module-shortcuts__empty {
  color: #607095;
  font-size: 12px;
  padding: 4px 0;
}

.module-shortcuts.is-compact {
  padding: 6px;
}

.module-shortcuts.is-compact .module-shortcuts__search {
  min-height: 30px;
}

.module-shortcuts.is-compact .module-shortcut-chip,
.module-shortcuts.is-compact .module-shortcuts__more-btn {
  min-height: 30px;
  padding-top: 4px;
  padding-bottom: 4px;
}

@media (max-width: 1023px) {
  .module-shortcuts {
    top: 54px;
  }

  .module-shortcuts__body {
    flex-direction: column;
  }

  .module-shortcuts__overflow {
    width: 100%;
  }

  .module-shortcuts__more-panel {
    left: 0;
    right: auto;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .module-shortcuts {
    padding: 6px 8px;
  }

  .module-shortcuts__top {
    gap: 6px;
  }

  /* search bar hidden by default on mobile; show when toggled */
  .module-shortcuts__search.search-hidden {
    display: none;
  }

  .module-shortcuts__actions {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: auto;
  }

  .module-shortcuts__icon-btn {
    width: 30px;
    height: 30px;
    border: 1px solid #d8e1f5;
    border-radius: 999px;
    background: #fff;
    color: #4a618f;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .module-shortcuts__collapse-btn {
    width: 30px;
    height: 30px;
  }

  .module-shortcuts__body {
    margin-top: 6px;
    flex-direction: row;
  }

  .module-shortcuts__scroll {
    gap: 6px;
    /* hide scrollbar on mobile for cleaner look */
    scrollbar-width: none;
  }

  .module-shortcuts__scroll::-webkit-scrollbar {
    display: none;
  }

  /* smaller chips on mobile: icon only until active */
  .module-shortcut-chip {
    padding: 5px 10px;
    font-size: 11px;
    min-height: 30px;
  }

  /* when search is open, show the full bar row */
  .module-shortcuts__top:has(.module-shortcuts__search:not(.search-hidden)) .module-shortcuts__search {
    flex: 1;
  }
}
</style>